const Detail =[
    {
        id: 1,
        Title: "product a", 
        Price: 300,
        Img: "./Images/shoe12.jpg",
        Name: "block heel",
    },
    {
        id: 2,
        Title: "product b", 
        Price: 700,
        Img: "./Images/shoe13.jpg",
        Name: "short heel",
    },
    {
        id: 3,
        Title: "product c", 
        Price: 400,
        Img: "./Images/shoe12.jpg",
        Name: "Flat heel",
    },
    {
        id: 4,
        Title: "product d", 
        Price: 950,
        Img: "./Images/shoe13.jpg",
        Name: "high heel",
    },
    {
        id: 5,
        Title: "product e", 
        Price: 480,
        Img: "./Images/shoe12.jpg",
        Name: "white sneaker",
    },
    {
        id: 6,
        Title: "product f", 
        Price: 550,
        Img: "./Images/shoe18.jpg",
        Name: "black sneaker",
    },
    {
        id: 7,
        Title: "product g", 
        Price: 1000,
        Img: "./Images/shoe15.jpg",
        Name: "multi-colored sneaker",
    },
    {
        id: 8,
        Title: "product h", 
        Price: 650,
        Img: "./Images/shoe18.jpg",
        Name: "red sneaker",
    },
    {
        id: 9,
        Title: "product i", 
        Price: 517,
        Img: "./Images/shoe20.jpg",
        Name: "red-colored sneaker",
    },
    {
        id: 10,
        Title: "product j", 
        Price: 318,
        Img: "./Images/shoe18.jpg",
        Name: "grey-colored sneaker",
    },
    {
        id: 11,
        Title: "product k", 
        Price: 600,
        Img: "./Images/shoe1.jpg",
        Name: "black-colored sneaker",
    },
    {
        id: 12,
        Title: "product l", 
        Price: 258,
        Img: "./Images/shoe16.jpg",
        Name: "blue-colored sneaker",
    },
    {
        id: 13,
        Title: "product m", 
        Price: 650,
        Img: "./Images/shoe1.jpg",
        Name: "white & red sneaker",
    },
    {
        id: 14,
        Title: "product n", 
        Price: 300,
        Img: "./Images/shoe16.jpg",
        Name: "black & white sneaker",
    },
    {
        id: 15,
        Title: "product o", 
        Price: 650,
        Img: "./Images/shoe1.jpg",
        Name: "white & red sneaker",
    },
    {
        id: 16,
        Title: "product p", 
        Price: 1000,
        Img: "./Images/shoe8.jpg",
        Name: "black & white sneaker",
    },
    {
        id: 17,
        Title: "product q", 
        Price: 800,
        Img: "./Images/shoe7.jpg",
        Name: "black & white sneaker",
    },
    {
        id: 18,
        Title: "product r", 
        Price: 1500,
        Img: "./Images/shoe8.jpg",
        Name: "black & white sneaker",
    },
    {
        id: 19,
        Title: "product s", 
        Price: 650,
        Img: "./Images/shoe7.jpg",
        Name: "black & white sneaker",
    },
    {
        id: 20,
        Title: "product t", 
        Price: 1200,
        Img: "./Images/shoe8.jpg",
        Name: "black & white sneaker",
    },
    {
        id: 21,
        Title: "product u", 
        Price: 1800,
        Img: "./Images/m1.jpg",
        Name: "black & white sneaker",
    },
    {
        id: 22,
        Title: "product v", 
        Price: 700,
        Img: "./Images/shoe5.jpg",
        Name: "black & white sneaker",
    },
    {
        id: 23,
        Title: "product w", 
        Price: 1300,
        Img: "./Images/m1.jpg",
        Name: "black & white sneaker",
    },
    {
        id: 24,
        Title: "product x", 
        Price: 900,
        Img: "./Images/shoe5.jpg",
        Name: "black & white sneaker",
    },
    {
        id: 25,
        Title: "product y", 
        Price: 1000,
        Img: "./Images/m1.jpg",
        Name: "black & white sneaker",
    },
]

export default Detail
